import React from "react";

import { Filter, useTranslate, ReferenceArrayInput } from "react-admin";

import TextInputEx from "../../../components/_extensions/react-admin/input/TextInputEx";

import { DateTimeInput } from "../../../components/inputs";

import { SelectEnumInput } from "components/inputs/SelectEnumInput";
import { UserRole } from "../../../entities/UserRole";
import AutocompleteArrayInputEx from "components/_extensions/react-admin/ra-ui-materialui/src/input/AutocompleteArrayInputEx";

const defaultSort = { field: "first_name", order: "DESC" };

export const LoginLogsFilter = (props) => {
	const translate = useTranslate();

	return (
		<Filter {...props}>
			<TextInputEx source="email" label={translate("osfc.filters.email")} />
			<ReferenceArrayInput
				source="user_id"
				reference="users"
				sort={defaultSort}
				filter={{ no_range: true }}
			>
				<AutocompleteArrayInputEx optionText="full_name" debounce={500} resettable />
			</ReferenceArrayInput>
			<DateTimeInput
				source="created_at.created_at_from"
				label={translate("osfc.filters.created_at.from")}
				withLocalTimeZone
			/>
			<DateTimeInput
				source="created_at.created_at_to"
				label={translate("osfc.filters.created_at.to")}
				withLocalTimeZone
			/>
			<SelectEnumInput enumObj={UserRole} translate={false} source="user_role" />
		</Filter>
	);
};
